import React from "react";

const works = [
  {
    date: "2025.3.16.",
    client: "えのきのこ🍄🌭V-Artist",
    clientLink: "https://x.com/enocinoco", // X（Twitter）リンク
    description: "Ending animation",
    video: "https://youtu.be/WRaDxREqWfs",
  },
  {
    date: "2025.2.22.",
    client: "Estelidae",
    clientLink: "https://x.com/estelidae", // X（Twitter）リンク
    description: "BRB animation",
    video: "https://youtu.be/w1RL1xzIXpw",
  },
  // 他の実績も追加できます
];

function MyWorks() {
  return (
    <div className="works-list">
      {works.map((work, index) => (
        <div className="work-item" key={index}>
          <p className="work-date">{work.date}</p>
          <p className="work-client">
            <a href={work.clientLink} target="_blank" rel="noopener noreferrer">
              {work.client}
            </a>
          </p>
          <p className="work-description">
            <a href={work.video} target="_blank" rel="noopener noreferrer">
              {work.description}
            </a>
          </p>
        </div>
      ))}
    </div>
  );
}

export default MyWorks;
